import { company, type SocialLink, type SocialPlatform } from '@/config/company';

import { FacebookIcon } from './FacebookIcon';
import { InstagramIcon } from './InstagramIcon';
import { LinkedInIcon } from './LinkedInIcon';
import { TikTokIcon } from './TikTokIcon';
import { XIcon } from './XIcon';
import { YouTubeIcon } from './YouTubeIcon';

export const socialIcons: Record<SocialPlatform, typeof FacebookIcon> = {
  facebook: FacebookIcon,
  instagram: InstagramIcon,
  youtube: YouTubeIcon,
  x: XIcon,
  linkedin: LinkedInIcon,
  tiktok: TikTokIcon,
};

/** The profiles with a real URL; a null URL hides that platform everywhere. */
export const activeSocials = (company.socials as readonly SocialLink[]).flatMap((s) =>
  s.url === null ? [] : [{ ...s, url: s.url }],
);
